<template>
    <div id="game">
        <!-- ----------------------------遊戲介紹開始---------------------------- -->
        <section class="cm-gameintro">
            <div class="container-fluid p-0">
                <div class="row no-gutters">
                    <div class="col">
                        <img class="img-fluid" :src=imageUrl>
                    </div>
                </div>
            </div>

            <div class="d-flex align-items-start justify-content-center mb-4 cm-triangle">
                <span class="cm-triangle-font">{{$t('game.GameBar')}}</span>
            </div>

            <div class="container-fluid py-md-5 py-sm-1 py-0">
                <GameContent :ismore="false" :content="infos"/>
            </div>
        </section>
        <!-- ----------------------------遊戲介紹結束---------------------------- -->
        <!-- ----------------------------更多遊戲開始---------------------------- -->
        <section class="py-0 cm-gameintro cm-game-showmoregame">
            <div class="container-fluid">
                <GameContent :ismore="true" :content="infos"/>
            </div>
        </section>
        <!-- ----------------------------更多遊戲結束---------------------------- -->
        <MoreGamesEnd></MoreGamesEnd>
    </div>
</template>

<script>
import axios from 'axios'
import GameContent from "@/components/GameContent";
import MoreGamesEnd from "@/components/MoreGamesEnd";
import store from '@/store/store-controller/store.js'
import * as BackendSetting from "@/assets/js/util/BackendSetting.js";
import eventBus from '@/assets/js/event/EventBus.js'

export default {
    name: "game",
    components: {
        GameContent,
        MoreGamesEnd
    },
    data() {
        return {
            infos: "",
            imageUrlDefault: require("@/assets/images/game/gametitle.jpg"),
            imageUrl: require("@/assets/images/game/gametitle.jpg"),
        }
    },
    created() {
        this.getGamesInfo(store.getters['storeI18n/getNowLanguage']);
    },
    mounted() {
        this.updateTopBackgroundImg();

        eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_SWITCH_PAGE_SHOW_ITEMS , false);
        
        // 更換語言時
        const self = this;
        eventBus.$on(process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_ROUTER_GAME, function(i18n) {
            self.getGamesInfo(i18n.locale);
            self.updateTopBackgroundImg(i18n);
        });

        eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_SWITCH_PAGE_SHOW_ITEMS , false);
    },
    methods: {
        async updateTopBackgroundImg(i18n = this.$i18n) {
            // 更新上方背景圖
            let imageUrl = await BackendSetting.getTopBackgroundImgUrl(i18n.locale);
            this.imageUrl = (imageUrl != "" ? imageUrl : this.imageUrlDefault);
        },
        getGamesInfo(i18nLocale)
        {
            let self = this;
            let bodyFormData = new FormData();
            bodyFormData.append('languageCode', i18nLocale);
            bodyFormData.append('ConditionBelong','NewCMGames');
            bodyFormData.append('ConditionCategory','system');
            axios({
                method: "post",
                url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/getGamesInfoAction.shtml",
                data: bodyFormData,
                timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                config: { headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }}
            })
            .then(function(response) {
                self.infos = response;
            })
            .catch(function () {
                alert(self.$i18n.t('common.Backend.Response.ConnectionFailed'));
            });
        }
    }       
};
</script>